import Vue from "vue";
import './plugins/vuetify'
import "./plugins/axios";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import i18n from "./i18n";
import VueStripeCheckout from 'vue-stripe-checkout';
import csrf from "./utils/csrf";

Vue.use(VueStripeCheckout, 'pk_live_nUDzx58FW4SLZfrM8FRZ6S9j');

Vue.config.productionTip = false;

Vue.mixin(csrf);

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount("#app");
